import React, { Component } from 'react';
import _ from 'lodash';
import config from '../config';
import {
    Link,
    Redirect
} from "react-router-dom";
import fetcher from "../context/fetcher";
import {AuthContext} from "../context/auth";

export default class Files extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            canUpload: props.hasOwnProperty("canUpload") ? props.canUpload : true,
            files: null,
            uploadPath: "",
            storage: "",
            prefix: "",
            isUploading: false,
            uploadProgress: 0,
            uploadError: null,
        }
        this.remove = this.remove.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.uploadClick = this.uploadClick.bind(this)
        this.uploadClickByServer = this.uploadClickByServer.bind(this)
        this.handleChangeUploadPath = this.handleChangeUploadPath.bind(this)
        this.onClickPrefix = this.onClickPrefix.bind(this)
        this.cancelUpload = this.cancelUpload.bind(this)
        this.remove = this.remove.bind(this)
        let prefix = (this.props.location.pathname + this.props.location.search).replace("/Files/", "").replace("/Files", "")
        console.log(prefix);
        this.getStore(prefix);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("componentDidUpdate", prevProps.location.pathname + prevProps.location.search, this.props.location.pathname + this.props.location.search)
        if(prevProps && (prevProps.location.pathname + prevProps.location.search) != (this.props.location.pathname + this.props.location.search)){
            let prefix = (this.props.location.pathname + this.props.location.search).replace("/Files/", "").replace("/Files", "")
            this.getStore(prefix);
        }
    }

    onClickPrefix(prefix)  {
        return (e) => {
            e.preventDefault();
            if (!e) e = window.event;                // Get the window event
            e.cancelBubble = true;                       // IE Stop propagation
            if (e.stopPropagation) e.stopPropagation();  // Other Broswers
            //this.getStore(prefix)
            if(this.props.history) {
                this.props.history.push("/Files/" + prefix)
            }
        }
    }
    getStore(prefix)  {
        console.trace(prefix);
        fetcher(`${config.API()}files/`+ prefix)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                let path = prefix.split("?")[0];
                let arr = path.substring(0, path.length-1).split("/");
                let upPrefix = arr.slice(0, arr.length-1).join("/");

                this.setState({
                    files: data.files,
                    storage: data.storage,
                    prefix: path,
                    uploadPath: path,
                    upPrefix: upPrefix ? upPrefix+"/" : "",
                    prevPrefix: this.state.prefix
                })
            }).catch(function(err) {
            console.error(err);
        });
    }

    removeDir = (eventId) => {
        return (e) => {
            if (window.confirm("Do you really want?")) {
                e.preventDefault();
                if (!e) e = window.event;                // Get the window event
                e.cancelBubble = true;                       // IE Stop propagation
                if (e.stopPropagation) e.stopPropagation();  // Other Broswers
                fetcher(`${config.API()}files/removedir`,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: eventId
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        this.getStore(this.state.prefix);
                    });

            }

        }
    }

    remove = (eventId) => {
        return (e) => {
            if (window.confirm("Do you really want?")) {
                e.preventDefault();
                if (!e) e = window.event;                // Get the window event
                e.cancelBubble = true;                       // IE Stop propagation
                if (e.stopPropagation) e.stopPropagation();  // Other Broswers
                fetcher(`${config.API()}files/remove`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: eventId
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        this.getStore(this.state.prefix);
                    });
            }
        }
    }

    handleChange = (id) => {
        return (e) => {
            e.preventDefault();
            if (!e) e = window.event;                // Get the window event
            e.cancelBubble = true;                       // IE Stop propagation
            if (e.stopPropagation) e.stopPropagation();  // Other Broswers
            let data = _.cloneDeep( this.state.files)
            data[id][e.target.name] =  e.target.value
            this.setState({files: data})
        }
    }
    handleChangeUploadPath = (e) => {
        e.preventDefault();
        if (!e) e = window.event;                // Get the window event
        e.cancelBubble = true;                       // IE Stop propagation
        if (e.stopPropagation) e.stopPropagation();  // Other Broswers
        this.setState({uploadPath: e.target.value})
    }

    getAuthHeadersFromLocalStorage = () => {
        try {
            const raw = localStorage["auth-m3t"];
            if (!raw) return {};
            const auth = JSON.parse(raw);
            if (auth && auth.token) {
                return { Authorization: `Bearer ${auth.token}` };
            }
        } catch (e) {}
        return {};
    };
    cancelUpload() {
        if (this._uploadXhr && this.state.isUploading) {
            this._uploadXhr.abort();
            this.setState({ isUploading: false, uploadError: 'Загрузка отменена пользователем.' });
        }
    }
    uploadClickByServer = (e) => {
        e.preventDefault();
        if (!e) e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();

        const formEl = document.forms.uploadForm;
        const formData = new FormData(formEl);
        formData.set('unzip', 'true');
        const url = `${config.API()}files/${this.state.uploadPath}`;

        const xhr = new XMLHttpRequest();
        this._uploadXhr = xhr;
        xhr.open('POST', url, true);

        // КРИТИЧНО: не ставим Content-Type — FormData сам проставит boundary
        const authHeaders = this.getAuthHeadersFromLocalStorage();
        Object.keys(authHeaders).forEach(k => xhr.setRequestHeader(k, authHeaders[k]));

        xhr.upload.onprogress = (ev) => {
            if (ev.lengthComputable) {
                const percent = Math.round((ev.loaded / ev.total) * 100);
                this.setState({ uploadProgress: percent });
            }
        };

        xhr.onloadstart = () => this.setState({ isUploading: true, uploadProgress: 0, uploadError: null });
        xhr.onerror = () => this.setState({ isUploading: false, uploadError: 'Ошибка сети во время загрузки.' });
        xhr.onabort  = () => this.setState({ isUploading: false, uploadError: 'Загрузка отменена.' });

        xhr.onload = () => {
            let data = null;
            try { data = JSON.parse(xhr.responseText || '{}'); } catch (e) {}
            if (xhr.status >= 200 && xhr.status < 300) {
                this.setState({ isUploading: false, uploadProgress: 100 });
                alert(JSON.stringify(data || { ok: true }, null, ' '));
                this.getStore(this.state.prefix);
                formEl.reset(); // очистим выбор файла
            } else {
                this.setState({
                    isUploading: false,
                    uploadError: (data && (data.message || data.error)) || `Ошибка сервера: ${xhr.status}`,
                });
            }
        };

        xhr.send(formData);
    }

    uploadClick = async (e) => {
        e.preventDefault();
        const formEl = document.forms.uploadForm;
        const file = formEl.querySelector('input[type="file"][name="file"]')?.files?.[0];
        if (!file) return this.setState({ uploadError: 'Выберите файл.' });

        const pathPrefix = (this.state.uploadPath || '').replace(/^\/+|\/+$/g, '');
        const presignUrl = `${config.API()}files-s3/presign/${encodeURI(pathPrefix)}`;

        let presign;
        try {
            presign = await fetcher(presignUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    fileName: file.name,
                    // можно явно передать, но сервер сам определит по имени:
                    // contentType: file.type,
                    // cacheControl: 'max-age=0, must-revalidate',
                    // acl: 'public-read',
                    // contentEncoding: 'gzip' | 'br'
                }),
            }).then(r => r.json());
        } catch {
            return this.setState({ uploadError: 'Ошибка при получении presigned URL.' });
        }

        const { url, headers } = presign;
        if (!url || !headers) return this.setState({ uploadError: 'Сервер не вернул заголовки для подписи.' });

        const xhr = new XMLHttpRequest();
        this._uploadXhr = xhr;
        xhr.open('PUT', url, true);

        // СТАВИМ РОВНО ТЕ ЖЕ ХЕДЕРЫ, ЧТО ВОШЛИ В ПОДПИСЬ:
        Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));

        xhr.upload.onprogress = (ev) => {
            if (ev.lengthComputable) this.setState({ uploadProgress: Math.round(ev.loaded / ev.total * 100) });
        };
        xhr.onloadstart = () => this.setState({ isUploading: true, uploadProgress: 0, uploadError: null });
        xhr.onerror = () => this.setState({ isUploading: false, uploadError: 'Ошибка сети при загрузке в S3.' });
        xhr.onabort  = () => this.setState({ isUploading: false, uploadError: 'Загрузка отменена.' });
        xhr.onload   = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                this.setState({ isUploading: false, uploadProgress: 100 });
                this.getStore(this.state.prefix);
                formEl.reset();
            } else {
                this.setState({ isUploading: false, uploadError: `Ошибка S3: ${xhr.status} ${xhr.statusText||''}` });
            }
        };

        xhr.send(file);
    };

    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        let list = [];
        if(this.state && this.state.files != null) {
            for(let x of this.state.files.CommonPrefixes){
                let arr = x.Prefix.split("/");
                arr.pop();
                let pr = arr.pop()
                list.push(
                    <tr key={x.Prefix}>
                        <td>
                            <button className="btn btn-outline-info  btn-sm" onClick={this.onClickPrefix(x.Prefix)} >
                                <i className="fa fa-folder"></i> {pr}
                            </button>
                        </td>
                        <td></td>
                        <td>
                            <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.removeDir(x.Prefix)} ><i className="fa fa-remove"></i></button>
                        </td>
                    </tr>
                )
            }
            for(let x of this.state.files.Contents){
                list.push(
                    <tr key={x.Key}>
                        <td>{_.last(x.Key.split("/"))}</td>
                        <td>
                            <a className="text-dark" target="_blank" href={`${this.state.storage}/${x.Key}`}>{`${this.state.storage}/${x.Key}`}</a>
                        </td>
                        <td>
                            <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.remove(x.Key)} ><i className="fa fa-remove"></i></button>
                        </td>
                    </tr>
                )
            }

        }

        return (
            <div className="card shadow w100">
                {this.state.canUpload && (
                    <div className="card-header py-3">
                        <form name="uploadForm" encType="multipart/form-data" method="POST">
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    name="path"
                                    value={this.state.uploadPath}
                                    onChange={this.handleChangeUploadPath}
                                    disabled={this.state.isUploading}
                                />
                            </div>


                            <input name="sign" value="filesUploadSecretDDD3" hidden/>
                            <input name="uploads" value="1" hidden/>

                            <div className="form-group d-flex align-items-center" style={{ gap: 8 }}>
                                <input type="file" name="file" disabled={this.state.isUploading} />
                                <button
                                    type="button"
                                    className="btn btn-icon btn-sm btn-success"
                                    onClick={this.uploadClick}
                                    disabled={this.state.isUploading}
                                >
                                    <span className="text">{this.state.isUploading ? 'Uploading…' : 'Upload'}</span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-icon btn-sm btn-primary"
                                    onClick={this.uploadClickByServer}
                                    disabled={this.state.isUploading}
                                >
                                    <span className="text">{this.state.isUploading ? 'Uploading…' : 'UploadAndUnZip'}</span>
                                </button>


                                {this.state.isUploading && (
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-sm btn-outline-danger"
                                        onClick={this.cancelUpload}
                                    >
                                        Cancel
                                    </button>
                                )}
                            </div>


                            <input type="hidden" name="unzip" value="true" />

                            {this.state.isUploading && (
                                <div className="mt-2">
                                    <div className="progress" style={{ height: 8 }}>
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{ width: `${this.state.uploadProgress}%` }}
                                            aria-valuenow={this.state.uploadProgress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        />
                                    </div>
                                    <small className="text-muted">{this.state.uploadProgress}%</small>
                                </div>
                            )}

                            {this.state.uploadError && (
                                <div className="alert alert-danger mt-2">{this.state.uploadError}</div>
                            )}
                        </form>
                    </div>
                )}

                <div className="card-body">
                    <div className="alert alert-info">
                        <button className="align-text-bottom btn btn-outline-dark  btn-sm" onClick={this.onClickPrefix(this.state.upPrefix)} >
                            <i className="fa fa-arrow-up"></i>
                        </button> <span className="h4 ml-4">{this.state.prefix}</span>

                        {this.state.files && this.state.files.NextContinuationToken && <button className="align-text-bottom btn btn-outline-dark  btn-sm r" onClick={this.onClickPrefix(this.state.prefix + "?continuationToken="+encodeURIComponent(this.state.files.NextContinuationToken))} >
                            <i className="fa fa-arrow-right"></i> nextPage
                        </button>
                        }
                        {false && <button className="align-text-bottom btn btn-outline-dark  btn-sm r" onClick={this.onClickPrefix(this.state.prevPrefix)} >
                            <i className="fa fa-arrow-left"></i> prevPage
                        </button>
                        }

                    </div>
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>file</th>
                                <th>src</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {list}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}